"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModelConstants;
(function (ModelConstants) {
    ModelConstants["ComputeDraftModel"] = "abb.pamEngineering.assetMonitorType.draft";
    ModelConstants["ComputeDraftType"] = "abb.pamEngineering.assetMonitorType.draft@1";
    ModelConstants["SceModel"] = "abb.ia.sce.engineering";
    ModelConstants["SceType"] = "abb.ia.sce.engineering@3";
    ModelConstants["SceInstanceModel"] = "abb.ia.sce.engineering.instance";
    ModelConstants["SceInstanceType"] = "abb.ia.sce.engineering.instance@3";
    ModelConstants["MappingModel"] = "abb.ia.deviceType.mapping";
    ModelConstants["MappingType"] = "abb.ia.deviceType.mapping@2";
    ModelConstants["SupportedModels"] = "abb.ability.model.supportedModels";
    ModelConstants["SupportedModelsTypeId"] = "abb.ability.scemodule.supportedModelsType";
    ModelConstants["FunctionTypeModel"] = "abb.ability.conditioningMonitor.function";
    ModelConstants["AssetMonitorModel"] = "abb.ability.conditionMonitor";
    ModelConstants["AlarmDefModel"] = "abb.ability.am.alarm";
    ModelConstants["AlarmDefTypeId"] = "abb.ability.am.alarm.conditionAlarm";
    ModelConstants["AssetCriticalityModel"] = "abb.ability.am.assetCriticality";
    ModelConstants["AssetCriticalityObjectTypeModel"] = "abb.generic.assetCriticalityObject";
    ModelConstants["AssetCriticalityObjectTypeTypeId"] = "abb.generic.assetCriticalityObjectType";
    ModelConstants["AssetCriticalitySceModelTypeATypeId"] = "abb.ia.sce.engineering.assetCriticalityTypeA";
    ModelConstants["AssetCriticalitySceModelTypeBTypeId"] = "abb.ia.sce.engineering.assetCriticalityTypeB";
    ModelConstants["AssetCriticalitySceModelTypeCTypeId"] = "abb.ia.sce.engineering.assetCriticalityTypeC";
    ModelConstants["AssetCriticalitySceModelTypeDTypeId"] = "abb.ia.sce.engineering.assetCriticalityTypeD";
    ModelConstants["AssetCriticalityATypeId"] = "AssetCriticalityTypeAModel";
    ModelConstants["AssetCriticalityBTypeId"] = "AssetCriticalityTypeBModel";
    ModelConstants["AssetCriticalityCTypeId"] = "AssetCriticalityTypeCModel";
    ModelConstants["AssetCriticalityDTypeId"] = "AssetCriticalityTypeDModel";
    ModelConstants["SupportedConditionMonitorModels"] = "abb.ability.model.supportedConditionMonitorModels";
    ModelConstants["supportedConditionMonitorModelsTypeId"] = "abb.ability.scemodule.supportedConditionMonitorModelsType";
    ModelConstants["FunctionEndPointModels"] = "abb.ability.model.sce.endpoint.urls";
    ModelConstants["FunctionEndPointModelsTypeId"] = "abb.ability.type.sce.endpoint.urls";
})(ModelConstants = exports.ModelConstants || (exports.ModelConstants = {}));
//# sourceMappingURL=ModelConstants.js.map